import React from 'react';
import { Form, Input, TextArea, Button, Select } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import './Contact.css';

const Support = () => {
  const { t } = useTranslation();

  const supportOptions = [
    { key: 'a', text: t('financialDepartment'), value: 'accounting' },
    { key: 's', text: t('support'), value: 'support' },
  ];

  return (
    <div className="supportPage">
      {/* <div className="supportBanner">
        <Header
          as="h1"
          content={t('supportHeader')}
          style={{
            fontWeight: 'bold',
            color: '#fff',
          }}
        />
        <Header
          as="h3"
          content={t('supportContactUs')}
          style={{
            fontWeight: 'normal',
            color: '#fff',
          }}
        />
      </div> */}
      <div className="supportHeader">
        <h2>{t('needHelp')}</h2>
        <p>{t('contactWithUs')}</p>
      </div>
      <Form className="contactForm">
        <Form.Group widths="two">
          <Form.Field
            id="form-input-control-name"
            control={Input}
            label={t('firstname')}
            placeholder={t('firstname')}
          />
        </Form.Group>
        <Form.Group widths="two">
          <Form.Field
            id="form-input-control-error-email"
            className="emailField"
            control={Input}
            label={t('email')}
            placeholder="mail@server.com"
          />
        </Form.Group>
        <Form.Group widths="two">
          <Form.Field
            control={Select}
            options={supportOptions}
            label={{ children: t('department'), htmlFor: 'form-select-control-department' }}
            placeholder={t('pleaseChoose')}
            search
            searchInput={{ id: 'form-select-control-department' }}
          />
        </Form.Group>
        <Form.Group widths="two">
          <Form.Field
            id="form-input-control-subject"
            control={Input}
            label={t('subject')}
            placeholder={t('subject')}
          />
        </Form.Group>
        <Form.Field
          className="half"
          id="form-textarea-control-body"
          control={TextArea}
          label={t('messageContent')}
          placeholder={t('messageContent')}
        />
        <Form.Field
          id="form-button-control-public"
          className="formBtn vButton colorPrimary"
          control={Button}
          content={t('send')}
        />
      </Form>
    </div>
  );
};

export default Support;
